import { CSSProperties, FC } from 'react'

import Icon from '~/src/components/generic/PhosphorIcons/Icon'

import { tw } from '~/lib/utils'
import colors from '~/config/colorsScheme'

type Props = {
  color?: string
  size?: number
  className?: string
  style?: CSSProperties
}

const Spinner: FC<Props> = ({ color, size, className, style }) => (
  <span className={tw('animate-spin duration-1000', className)} style={style}>
    <Icon
      color={color ?? colors.blue[500]}
      name="SpinnerIcon"
      size={String(size ?? 40)}
    />
  </span>
)

export default Spinner
